import React, { useState,useEffect } from "react";
import axios from "axios";
import MDButton from "components/MDButton";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Modal from "@mui/material/Modal";
import { useNavigate } from "react-router-dom";
import { useAlerta } from "utils/alertas";

export default function Reportes() {
  const navigate = useNavigate();
  const [filtroInscritos, setFiltroInscritos] = useState("todos");
  const [fechaInicioInscritos, setFechaInicioInscritos] = useState("");
  const [fechaFinInscritos, setFechaFinInscritos] = useState("");
  const [gestionInscritos, setGestionInscritos] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [metodo, setMetodo] = useState("");
  const [datoestudiante, setDatoEstudiante] = useState("");
  const [modalHoyOpen, setModalHoyOpen] = useState(false);
  const [egresos, setEgresos] = useState([{ concepto: "", monto: "", tipo: "efectivo" }]);
  const [reporteHoyUrl, setReporteHoyUrl] = useState("");
  const token = sessionStorage.getItem("access_token");
  const [formato, setFormato] = useState("");
  const [formato_documento, setFormatoDocumento] = useState("");
  const [fechaInicioMarketing, setFechaInicioMarketing] = useState("");
  const [fechaFinMarketing, setFechaFinMarketing] = useState("");
  const [formatoMarketing, setFormatoMarketing] = useState("");
  const [gestionRendimiento, setGestionRendimiento] = useState("");
  const [formatoRendimiento, setFormatoRendimiento] = useState("");
  const [filtroRendimiento, setFiltroRendimiento] = useState("");
  const [formatoInscritos, setFormatoInscritos] = useState("");
  const [programasEstudiante, setProgramasEstudiante] = useState([]);
  const [carreraBoletin, setCarreraBoletin] = useState("");
  const [gestionNotas, setGestionNotas] = useState("");
  const [cargandoReporte, setCargandoReporte] = useState(false);
  const [formatoArrastre, setFormatoArrastre] = useState("");
  const [formatoFaltas, setFormatoFaltas] = useState("");
  const [formatoBoletin, setFormatoBoletin] = useState("");
  const [gestiones, setGestiones] =useState([]);
  const [gestionesBoletin, setGestionesBoletin] = useState([]);
  const [formatoDocumentos, setFormatoDocumentos] = useState("");
  const [grupoNotas, setGrupoNotas] = useState("");
  const [materiaNotas, setMateriaNotas] = useState("");
  const [semestreNotas, setSemestreNotas] = useState("");
  const [formatoNotas, setFormatoNotas] = useState("");
  const [materiasDisponibles, setMateriasDisponibles] = useState([]);
  const [pensumSeleccionado, setPensumSeleccionado] = useState("");
  const [gruposDisponibles, setGruposDisponibles] = useState([]);
  const [programasUnificados, setProgramasUnificados] = useState([]);
  const [programaSeleccionado, setProgramaSeleccionado] = useState({ id: "", tipo: "" });
  const [programaNotas, setProgramaNotas] = useState({ id: "", tipo: "" });
  const [carreras, setCarreras] = useState([]);
  const [materias, setMaterias] = useState([]);
  const [materiaSeleccionada, setMateriaSeleccionada] = useState("");
  const [programaRanking, setProgramaRanking] = useState({ id: "", tipo: "" });
  const [pensumsRanking, setPensumsRanking] = useState([]);
  const [semestres, setSemestres] = useState([]);
  const [semestreSeleccionado, setSemestreSeleccionado] = useState("");
  const [semestreRanking, setSemestreRanking] = useState("");
  const VALOR_INSTITUCIONAL = "institucional-todas";
  const { mostrarAlerta } = useAlerta();
  const [tipoReporteIngreso, setTipoReporteIngreso] = useState("general");
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userRol = user?.rol;
  const userId = user?.id;

  useEffect(() => {
  if (!programaRanking.id || programaRanking.id === "todas") {
    return;
  }

  const cargarSemestresRanking = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/semestre/${programaRanking.tipo}/${programaRanking.id}`;
      
      console.log("Cargando semestres RANKING:", url);

      const res = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const data = await res.json();

      setSemestres(Array.isArray(data) ? data : (data.data || []));

      // limpiar selección anterior
      setSemestreRanking("");

    } catch (err) {
      console.error("Error cargando semestres ranking:", err);
      setSemestres([]);
    }
  };

  cargarSemestresRanking();
}, [programaRanking]);

  useEffect(() => {
    if ( !gestionNotas || !semestreSeleccionado) {
      setGruposDisponibles([]);
      return;
    }

    const cargarGrupos = async () => {
      try {
        const url = `${process.env.REACT_APP_API_URL}/grupos/${gestionNotas}/${semestreSeleccionado}`;
        
        console.log("Cargando grupos desde:", url);

        const res = await fetch(url, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });

        const data = await res.json();

        setGruposDisponibles(data.data || []);
      } catch (err) {
        console.error("Error cargando grupos:", err);
        setGruposDisponibles([]);
      }
    };

    cargarGrupos();
  }, [programaNotas, gestionNotas, semestreSeleccionado]);

  useEffect(() => {
  if (!programaNotas.id || !programaNotas.tipo) {
    setSemestres([]);
    return;
  }

  const cargarSemestres = async () => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/semestre/${programaNotas.tipo}/${programaNotas.id}`;
      
      console.log("Cargando semestres desde:", url);

      const res = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      const data = await res.json();

      // 🔥 Ajusta según cómo venga tu API
      setSemestres(Array.isArray(data) ? data : (data.data || []));

      // limpiamos selección anterior
      setSemestreSeleccionado("");

    } catch (err) {
      console.error("Error cargando semestres:", err);
      setSemestres([]);
    }
  };

  cargarSemestres();
}, [programaNotas]);

useEffect(() => {
  if (!grupoNotas) return;

  const cargarMaterias = async () => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/grupos/${grupoNotas}/materias`, {
      headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
    });
    const result = await res.json();
    
    // IMPORTANTE: result.data es el array que vimos en tu consola
    setMaterias(result.data || []); 
  };

  cargarMaterias();
}, [grupoNotas]);

  useEffect(() => {
  // Solo disparamos si tenemos ambos datos
  if (!programaSeleccionado.id || !programaSeleccionado.tipo) {
    return;
  }

  const cargarPensumsPorPrograma = async () => {
    try {
      const { tipo, id } = programaSeleccionado;
      const res = await fetch(`${process.env.REACT_APP_API_URL}/${tipo}/${id}/pensums`, {
        headers: { Authorization: `Bearer ${token}`, Accept: "application/json" },
      });
      const data = await res.json();
      
      // Ajusta esto según si tu API devuelve el array directo o un objeto
      setPensumsFiltrados(Array.isArray(data) ? data : (data.pensums || []));
      
      // Limpiamos selecciones hijas para evitar errores de IDs viejos
      setPensumSeleccionado("");
      setGruposDisponibles([]);
    } catch (err) {
      console.error("Error al obtener pensums:", err);
      setPensumsFiltrados([]);
    }
  };

  cargarPensumsPorPrograma();
}, [programaSeleccionado, token]);

  // Estados para Mejores Promedios
  const [gestionPromedios, setGestionPromedios] = useState("");
  const [limitePromedios, setLimitePromedios] = useState("10");
  const [formatoPromedios, setFormatoPromedios] = useState("");

  const handleReporteNotasGrupo = () => {
    if (!grupoNotas || !formatoNotas) {
      alert("Seleccione al menos grupo y formato");
      return;
    }
    const token = sessionStorage.getItem("access_token");
    // Estructura: /notas-grupo/{grupo}/{formato}?materia_id=...&semestre=...
    const query = `?materia_id=${materiaSeleccionada}&semestre_id=${semestreSeleccionado}&token=${token}`;
    const url = `${process.env.REACT_APP_API_URL}/reportes/notas-grupo/${grupoNotas}/${formatoNotas}${query}`;
    window.open(url, "_blank");
  };
  const handleReporteMejoresPromedios = () => {
    if (!formatoPromedios) {
      alert("Seleccione formato");
      return;
    }

    const token = sessionStorage.getItem("access_token");

    const query = `?token=${token}`
      + `&tipo=${programaRanking.tipo || ''}`
      + `&programa_id=${programaRanking.id || ''}`
      + `&gestion=${gestionRendimiento || ''}`
      + `&semestre_id=${semestreRanking || ''}`;

    const url = `${process.env.REACT_APP_API_URL}/reportes/mejores-promedios/${formatoPromedios}${query}`;

    console.log("URL FINAL:", url); // 🔥 para debug

    window.open(url, "_blank");
  };

  useEffect(() => {
  if (!datoestudiante || !carreraBoletin) return;

  const fetchGestiones = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/reportes/gestiones-estudiante/${datoestudiante}?carrera_id=${carreraBoletin}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );

      const data = await res.json();
      console.log("GESTIONES BACK:", data);
      setGestionesBoletin(data || []);
    } catch (err) {
      console.error("Error cargando gestiones:", err);
    }
  };

  fetchGestiones();
}, [datoestudiante, carreraBoletin]);
  
  const cargarGestiones = async () => {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/gestiones`, {
      headers: { Authorization: `Bearer ${token}` }
    });

    setGestiones(res.data);
  };
  useEffect(() => {
      cargarGestiones(); // Cargamos los pensums en el inicio
    }, [token]);

  const handleReporteFaltas = () => {
    if (!formatoFaltas) {
      alert("Por favor seleccione un formato de documento");
      return;
    }

    const token = sessionStorage.getItem("access_token");
    const query = `?formato=${formatoFaltas}&token=${token}`;
    const url = `${process.env.REACT_APP_API_URL}/reportes/estudiantes-faltas${query}`;

    window.open(url, "_blank");
  };
  useEffect(() => {
  const cargarDatosInciales = async () => {
    try {
      const cabeceras = { 
        Authorization: `Bearer ${token}`, 
        Accept: "application/json" 
      };

      const [resCarreras, resModulos] = await Promise.all([
        fetch(`${process.env.REACT_APP_API_URL}/carreras`, { headers: cabeceras }),
        fetch(`${process.env.REACT_APP_API_URL}/modulos`, { headers: cabeceras })
      ]);

      const dataCarreras = await resCarreras.json();
      const dataModulos = await resModulos.json();

      // 1. Procesar Carreras (Vienen como Array directo [])
      const listaCarreras = (Array.isArray(dataCarreras) ? dataCarreras : []).map(c => ({
        id: c.id,
        display: `${c.nombre.toUpperCase()} (Carrera)`,
        tipo: "carrera"
      }));

      // 2. Procesar Módulos (Vienen dentro de { data: [...] })
      // Usamos dataModulos.data porque tu log dice que ahí están los 2 módulos
      const rawModulos = dataModulos.data || []; 
      const listaModulos = rawModulos.map(m => ({
        id: m.id,
        display: `${m.nombre.toUpperCase()} (Capacitación)`,
        tipo: "capacitacion"
      }));

      // 3. Unificar y Guardar
      setProgramasUnificados([...listaCarreras, ...listaModulos]);

    } catch (err) {
      console.error("Error al unificar programas:", err);
    }
  };

  cargarDatosInciales();
}, [token]);
  

  const handleReporteArrastre = () => {
  if (!formatoArrastre) {
    alert("Por favor seleccione un formato de documento");
    return;
  }

  const token = sessionStorage.getItem("access_token");
  const query = `?formato=${formatoArrastre}&token=${token}`;
  const url = `${process.env.REACT_APP_API_URL}/reportes/arrastres-general${query}`;

  window.open(url, "_blank");
};
  useEffect(() => {
  if (datoestudiante.length < 3) {
    setProgramasEstudiante([]);
    setCarreraBoletin("");
    return;
  }

  const buscarProgramas = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/usuarios/buscar-inscripciones/${datoestudiante}`, {
        headers: { Authorization: `Bearer ${token}`, Accept: "application/json" }
      });
      const data = await res.json();
      
      const programas = data.data || data.programas || [];

setProgramasEstudiante(programas);

if (programas.length > 0) {
  setCarreraBoletin(programas[0].carrera_id);
}
    } catch (err) {
      console.error("Error buscando inscripciones:", err);
    }
  };

  const timer = setTimeout(buscarProgramas, 500); // Debounce de medio segundo
  return () => clearTimeout(timer);
}, [datoestudiante]);
  const handleRendimiento = () => {
    if (!formatoRendimiento) {
      alert("Por favor seleccione un formato de documento");
      return;
    }
    
    const token = sessionStorage.getItem("access_token");
    
    // 🔥 2. AÑADIMOS EL FILTRO AL QUERY STRING
    const query = `?formato=${formatoRendimiento}&gestion=${gestionRendimiento}&filtro=${filtroRendimiento}&token=${token}`;
    const url = `${process.env.REACT_APP_API_URL}/reportes/rendimiento-academico${query}`;
    
    window.open(url, "_blank");
  };

  const handleGenerarMarketing = () => {
    if (!formatoMarketing) {
      alert("Por favor seleccione un formato de documento");
      return;
    }

    const queryParams = `?formato=${formatoMarketing}&fechaInicio=${fechaInicioMarketing}&fechaFin=${fechaFinMarketing}`;
    const url = `${process.env.REACT_APP_API_URL}/reportes/como-se-entero${queryParams}`;
    window.open(url, "_blank");
  };

  const handleIngresosHoy = async () => {
    if (!formato) {
      mostrarAlerta("Debe seleccionar un formato", "error");
      return;
    }

    try {
      const token = sessionStorage.getItem("access_token");

      const url = `${process.env.REACT_APP_API_URL}/reportes/ingresosHoy/${formato}?tipo=${tipoReporteIngreso}&usuario_id=${userId}`;

      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const blob = await response.blob();
      const fileURL = URL.createObjectURL(blob);

      window.open(fileURL, "_blank");
    } catch (error) {
      console.error(error);
      mostrarAlerta("No se pudo generar el reporte", "error");
    }
  };

  // --- Manejar cambios en egresos ---
  const handleEgresoChange = (index, field, value) => {
    const newEgresos = [...egresos];
    newEgresos[index][field] = value;
    setEgresos(newEgresos);
  };

  // --- Agregar nueva fila de egreso ---
  const agregarEgreso = () => {
    setEgresos([...egresos, { concepto: "", monto: "", tipo: "efectivo" }]);
  };
  const guardarEgresos = async () => {
    try {
      const token = sessionStorage.getItem("access_token");

      const egresosValidos = egresos.filter(e => e.concepto && e.monto);

      if (egresosValidos.length > 0) {
        await fetch(`${process.env.REACT_APP_API_URL}/egresos`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ egresos: egresosValidos }),
        });
      }

      mostrarAlerta("Egresos registrados correctamente", "success");
      setModalHoyOpen(false);
      setEgresos([{ concepto: "", monto: "", tipo: "efectivo" }]);
    } catch (error) {
      console.error(error);
      mostrarAlerta("Error al guardar egresos", "error");
    }
  };


  const handleGenerarIngresos = async () => {
    if (!fechaInicio || !fechaFin) {
      mostrarAlerta("Selecciona ambas fechas",'error');
      return;
    }
    if (!formato || formato === "" || formato === null) {
      mostrarAlerta("Debe seleccionar un formato para generar el reporte",'error');
      return;
    }

    try {
      const token = sessionStorage.getItem("access_token");
      const url = `${process.env.REACT_APP_API_URL}/reportes/ingresos/${fechaInicio}/${fechaFin}/${formato}?tipo=${tipoReporteIngreso}&usuario_id=${userId}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        mostrarAlerta("No se pudo generar el reporte. Verifica tus permisos o sesión.",'error');
        return;
      }

      const blob = await response.blob();

      const fileURL = URL.createObjectURL(blob);

      window.open(fileURL, "_blank");

      setTimeout(() => URL.revokeObjectURL(fileURL), 10000);

    } catch (error) {
      console.error("Error al abrir el reporte:", error);
      alert("Ocurrió un error al intentar abrir el archivo.");
    }
  };


  const handleInscritos = () => {
    if (!formatoInscritos) {
      mostrarAlerta("Debe seleccionar un formato", "error");
      return;
    }

    const params = new URLSearchParams();

    params.append("filtro", filtroInscritos);

    if (filtroInscritos === "fechas") {
      if (!fechaInicioInscritos || !fechaFinInscritos) {
        mostrarAlerta("Debe seleccionar ambas fechas", "error");
        return;
      }

      if (fechaInicioInscritos > fechaFinInscritos) {
        mostrarAlerta(
          "La fecha inicial no puede ser posterior a la fecha final",
          "error"
        );
        return;
      }

      params.append("fecha_inicio", fechaInicioInscritos);
      params.append("fecha_fin", fechaFinInscritos);
    }

    if (filtroInscritos === "gestion") {
      if (!gestionInscritos) {
        mostrarAlerta("Debe seleccionar una gestión", "error");
        return;
      }

      params.append("gestion_id", gestionInscritos);
    }

    const url = `${
      process.env.REACT_APP_API_URL
    }/reportes/inscritos/${formatoInscritos}?${params.toString()}`;

    window.open(url, "_blank");
  };
  const handleTipoPago = () => {
    if (!formato_documento) {
      alert("Por favor seleccione un formato de documento");
      return;
    }
    const url = `${process.env.REACT_APP_API_URL}/reportes/deudores/${formato_documento}`;
    window.open(url, "_blanck");
  };

  const handleHistorialAcademico = (tipo) => {
    if (!datoestudiante) {
      alert("Ingrese el nombre o CI o codigo del estudiante");
      return;
    }

    const url = `${process.env.REACT_APP_API_URL}/reportes/historial/${datoestudiante}?tipo=${tipo}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="flex-start"
        p={3}
      >
        <MDButton
          variant="contained"
          color="warning"
          onClick={() => setModalHoyOpen(true)}
        >
          Registrar Egresos
        </MDButton>
      </Box>
      <Box
        p={3}
        display="grid"
        gridTemplateColumns={{
          xs: "1fr",              // celular
          sm: "1fr",              // tablets pequeñas
          md: "repeat(2, 1fr)",   // desde laptop
          lg: "repeat(2, 1fr)",   // 👈 mantenemos 2 también en grande
        }}
        gap={3}
      >
        {/* --- Bloque de Ingresos --- */}
        <Box p={3} borderRadius={2} boxShadow={2} bgcolor="#fff" display="flex" flexDirection="column" gap={2}>
          <Typography variant="h6">Reporte de Ingresos por Fecha</Typography>
          <Box 
            display="flex" 
            gap={2}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <TextField
              label="Fecha Inicio"
              type="date"
              value={fechaInicio}
              onChange={(e) => setFechaInicio(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            <TextField
              label="Fecha Fin"
              type="date"
              value={fechaFin}
              onChange={(e) => setFechaFin(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Box>
          {(userRol === 1 || userRol === 2) && (
            <TextField
              select
              fullWidth
              label="Tipo de Reporte"
              value={tipoReporteIngreso}
              onChange={(e) => setTipoReporteIngreso(e.target.value)}
              SelectProps={{ native: true }}
            >
              <option value="general">General (Todos)</option>
              <option value="mio">Solo Mis Registros</option>
            </TextField>
          )}
            <TextField
              select
              label="Formato"
              value={formato}
              onChange={(e) => setFormato(e.target.value)}
              SelectProps={{ native: true }}
              fullWidth
            >
              <option value=""></option>
              <option value="pdf">PDF</option>
              <option value="excel">Excel</option>
            </TextField>
          <Box display="flex" width="100%" mt={2} gap={1}>
            <Box display="flex" width="100%" mt={2} gap={1}>
              <MDButton variant="contained" color="info" onClick={handleGenerarIngresos} sx={{ flex: 1 }}>
                Generar
              </MDButton>
              <MDButton
                variant="contained"
                color="primary"
                onClick={handleIngresosHoy}
                sx={{ flex: 1 }}
              >
                Reporte de Hoy
              </MDButton>
            </Box>
          </Box>

        {/* --- Modal de ingresos hoy con egresos --- */}
        <Modal open={modalHoyOpen} onClose={() => setModalHoyOpen(false)}>
          <Box
            p={4}
            bgcolor="#fff"
            borderRadius={2}
            width="600px"
            maxHeight="80vh" // para que no se salga de la pantalla
            overflow="auto"
            position="absolute"
            top="50%"
            left="50%"
            sx={{ transform: 'translate(-50%, -50%)' }}
            display="flex"
            flexDirection="column"
            gap={2}
          >
            <Typography variant="h6">Registrar Egresos y Ver Reporte de Hoy</Typography>

            {egresos.map((e, index) => (
              <Box key={index} display="flex" gap={2}>
                <TextField
                  label="Concepto"
                  value={e.concepto}
                  onChange={(ev) => handleEgresoChange(index, "concepto", ev.target.value)}
                  fullWidth
                />
                <TextField
                  label="Monto"
                  type="number"
                  value={e.monto}
                  onChange={(ev) => handleEgresoChange(index, "monto", ev.target.value)}
                  fullWidth
                />
                <TextField
                  select
                  label="Tipo"
                  SelectProps={{ native: true }}
                  value={e.tipo}
                  onChange={(ev) => handleEgresoChange(index, "tipo", ev.target.value)}
                  sx={{ minWidth: "150px" }}
                >
                  <option value="efectivo">Efectivo</option>
                  <option value="no_efectivo">No Efectivo</option>
                </TextField>
              </Box>
            ))}

            <MDButton variant="outlined" color="info" onClick={agregarEgreso}>
              + Agregar Egreso
            </MDButton>

            <MDButton variant="contained" color="success" onClick={guardarEgresos}>
              Guardar Egresos
            </MDButton>
          </Box>
        </Modal>
      </Box>
        {/* Bloque de Estudiantes Inscritos */}
        <Box
          p={3}
          borderRadius={2}
          boxShadow={2}
          bgcolor="#fff"
          display="flex"
          flexDirection="column"
          gap={2}
        >
          <Typography variant="h6">
            Reporte de Estudiantes Inscritos
          </Typography>

          {/* Tipo de filtro */}
          <TextField
            select
            label="Filtrar por"
            value={filtroInscritos}
            onChange={(e) => setFiltroInscritos(e.target.value)}
            SelectProps={{ native: true }}
            fullWidth
          >
            <option value="todos">Todos los estudiantes</option>
            <option value="fechas">Rango de fechas</option>
            <option value="gestion">Gestión académica</option>
          </TextField>

          {/* Rango de fechas */}
          {filtroInscritos === "fechas" && (
            <Box
              display="flex"
              gap={2}
            >
              <TextField
                label="Fecha inicial"
                type="date"
                value={fechaInicioInscritos}
                onChange={(e) => setFechaInicioInscritos(e.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />

              <TextField
                label="Fecha final"
                type="date"
                value={fechaFinInscritos}
                onChange={(e) => setFechaFinInscritos(e.target.value)}
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Box>
          )}

          {/* Gestión académica */}
          {filtroInscritos === "gestion" && (
            <TextField
              select
              label="Gestión académica"
              value={gestionInscritos}
              onChange={(e) => setGestionInscritos(e.target.value)}
              SelectProps={{ native: true }}
              fullWidth
            >
              <option value="">Seleccionar gestión</option>

              {gestiones.map((g) => (
                <option key={g.id} value={g.id}>
                  {g.nombre}
                </option>
              ))}
            </TextField>
          )}

          {/* Formato */}
          <TextField
            select
            label="Formato"
            value={formatoInscritos}
            onChange={(e) => setFormatoInscritos(e.target.value)}
            SelectProps={{ native: true }}
            fullWidth
          >
            <option value=""></option>
            <option value="pdf">PDF</option>
            <option value="excel">Excel</option>
          </TextField>

          <MDButton
            variant="contained"
            color="info"
            onClick={handleInscritos}
          >
            Generar
          </MDButton>
        </Box>
        <Box
          p={3}
          borderRadius={2}
          boxShadow={2}
          bgcolor="#fff"
          display="flex"
          flexDirection="column"
          gap={2}
        >
          <Typography variant="h6">Reporte de deudores</Typography>
            <Box 
              display="flex" 
              gap={2}
              flexDirection={{ xs: "column", sm: "row" }}
            >
              <TextField
                select
                label="Formato del documento"
                SelectProps={{ native:true }}
                value={formato_documento}
                onChange={(e) => setFormatoDocumento(e.target.value)}
                fullWidth
              >
                <option value=""></option>
                <option value="excel">Documento Excel</option>
                <option value="pdf">Documento PDF</option>
              </TextField>
            </Box>
          {/* Botón debajo */}
          <Box display="flex" width="100%" mt={2}>
            <MDButton
              variant="contained"
              color="info"
              onClick={handleTipoPago}
              fullWidth
            >
              Generar
            </MDButton>
          </Box>
        </Box>
        <Box
          p={3}
          borderRadius={2}
          boxShadow={2}
          bgcolor="#fff"
          display="flex"
          flexDirection="column"
          gap={2}
        >
          <Typography variant="h6">Historial Académico</Typography>

          <TextField
            label="Nombre, CI, codigo del estudiante"
            value={datoestudiante}
            onChange={(e) => setDatoEstudiante(e.target.value)}
            fullWidth
          />

          <Box 
            display="flex" 
            gap={2}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <MDButton
              variant="contained"
              color="error"
              onClick={() => handleHistorialAcademico("pdf")}
              sx={{ flex: 1 }}
            >
              PDF
            </MDButton>

            <MDButton
              variant="contained"
              color="success"
              onClick={() => handleHistorialAcademico("excel")}
              sx={{ flex: 1 }}
            >
              Excel
            </MDButton>
          </Box>
        </Box>
        {/* --- NUEVO: Reporte de Marketing (Cómo se enteró) --- */}
        <Box
          p={3}
          borderRadius={2}
          boxShadow={2}
          bgcolor="#fff"
          display="flex"
          flexDirection="column"
          gap={2}
        >
          <Typography variant="h6">Reporte: Medios de Prospección</Typography>
          <Typography variant="body2" color="text.secondary">
            Descubre a través de qué medios se enteran los estudiantes (Redes, Amigos, etc.)
          </Typography>

          <Box 
            display="flex" 
            gap={2}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <TextField
              label="Fecha Inicio"
              type="date"
              value={fechaInicioMarketing} // Recomiendo crear un estado independiente
              onChange={(e) => setFechaInicioMarketing(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            <TextField
              label="Fecha Fin"
              type="date"
              value={fechaFinMarketing}
              onChange={(e) => setFechaFinMarketing(e.target.value)}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
          </Box>

          <TextField
            select
            label="Formato de documento"
            SelectProps={{ native: true }}
            value={formatoMarketing}
            onChange={(e) => setFormatoMarketing(e.target.value)}
            fullWidth
          >
            <option value=""></option>
            <option value="pdf">Documento PDF</option>
            <option value="excel">Documento Excel</option>
          </TextField>

          <Box display="flex" width="100%" mt={2}>
            <MDButton
              variant="contained"
              color="info"
              onClick={handleGenerarMarketing}
              fullWidth
            >
              Generar Reporte de Prospección
            </MDButton>
          </Box>
        </Box>
        <Box p={3} borderRadius={2} boxShadow={2} bgcolor="#fff" display="flex" flexDirection="column" gap={2}>
          <Typography variant="h6">Reporte de Rendimiento Académico</Typography>
          <Typography variant="body2" color="text.secondary">
            Monitorea la cantidad de estudiantes aprobados y reprobados.
          </Typography>

          <Box 
            display="flex" 
            gap={2}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <TextField
              select
              label="Gestión"
              SelectProps={{ native: true }}
              value={gestionRendimiento}
              onChange={(e) => setGestionRendimiento(e.target.value)}
              fullWidth
            >
              <option value=""></option>
              {gestiones.map((g, i) => (
                <option key={g.id} value={g.nombre}>
                  {g.nombre}
                </option>
              ))}
            </TextField>

            {/* 🔥 3. NUEVO TEXTFIELD SELECTOR DEL FILTRO DE APROBACIÓN */}
            <TextField
              select
              label="Filtrar por Estado"
              SelectProps={{ native: true }}
              value={filtroRendimiento}
              onChange={(e) => setFiltroRendimiento(e.target.value)}
              fullWidth
            >
              <option value=""></option>
              <option value="">Todos</option>
              <option value="aprobado">Aprobados</option>
              <option value="reprobado">Reprobados</option>
            </TextField>
          </Box>

          <TextField
            select
            label="Formato del documento"
            SelectProps={{ native: true }}
            value={formatoRendimiento}
            onChange={(e) => setFormatoRendimiento(e.target.value)}
            fullWidth
          >
            <option value=""></option>
            <option value="pdf">Documento PDF</option>
            <option value="excel">Documento Excel</option>
          </TextField>

          <Box display="flex" width="100%" mt={2}>
            <MDButton variant="contained" color="info" onClick={handleRendimiento} fullWidth>
              Generar Reporte de Rendimiento
            </MDButton>
          </Box>
        </Box>
        {/* --- NUEVO: Boletín de Notas --- */}
        <Box p={3} borderRadius={2} boxShadow={2} bgcolor="#fff" display="flex" flexDirection="column" gap={2}>
          <Typography variant="h6">Boletín de Notas del Estudiante</Typography>
          
          <TextField
            label="Código, CI o Nombre del estudiante"
            value={datoestudiante}
            onChange={(e) => setDatoEstudiante(e.target.value)}
            fullWidth
          />

          <Box 
            display="flex" 
            gap={2}
            flexDirection={{ xs: "column", sm: "row" }}
          >
            <TextField
              select
              label="Carrera / Capacitación cursada"
              SelectProps={{ native: true }}
              value={carreraBoletin}
              onChange={(e) => setCarreraBoletin(e.target.value)}
              disabled={programasEstudiante.length === 0}
              fullWidth
            >
              <option value=""></option>
              {programasEstudiante.map((p, index) => (
                <option key={index} value={p.carrera_id}>
                  {p.nombre_carrera} ({p.tipo_programa})
                </option>
              ))}
            </TextField>

            <TextField
              select
              label="Gestión"
              SelectProps={{ native: true }}
              value={gestionesBoletin}
              onChange={(e) => setGestionesBoletin(e.target.value)} // ✅ CORRECTO
              disabled={gestiones.length === 0}
              fullWidth
            >
              <option value=""></option>
              {gestiones.map((g) => (
                <option key={g.id} value={g.id}> {/* ✅ ID, NO nombre */}
                  {g.nombre}
                </option>
              ))}
            </TextField>
          </Box>

          {/* 🔥 NUEVO SELECT DE FORMATO PARA EL BOLETÍN */}
          <TextField
            select
            label="Formato del documento"
            SelectProps={{ native: true }}
            value={formatoBoletin}
            onChange={(e) => setFormatoBoletin(e.target.value)}
            disabled={programasEstudiante.length === 0}
            fullWidth
          >
            <option value=""></option>
            <option value="pdf">Documento PDF</option>
            <option value="excel">Documento Excel</option>
          </TextField>

          <MDButton
            variant="contained"
            color="warning"
            fullWidth
            onClick={() => {
              if (!datoestudiante || !carreraBoletin || !formatoBoletin) {
                alert("Por favor escribe los datos del estudiante, selecciona un programa y un formato.");
                return;
              }
              
              const token = sessionStorage.getItem("access_token");
              
              // 🔗 Concatenamos el formatoBoletin en la URL
              const url = `${process.env.REACT_APP_API_URL}/reportes/boletin/${datoestudiante}?carrera_id=${carreraBoletin}&gestionId=${gestionesBoletin || "2026"}&formato=${formatoBoletin}&token=${token}`;
              
              window.open(url, "_blank");
            }}
            disabled={programasEstudiante.length === 0}
          >
            Descargar Boletín (Media Hoja)
          </MDButton>
        </Box>
        {/* --- NUEVO: Reporte General de Arrastres --- */}
        <Box
          p={3}
          borderRadius={2}
          boxShadow={2}
          bgcolor="#fff"
          display="flex"
          flexDirection="column"
          gap={2}
        >
          <Typography variant="h6">Reporte General de Arrastres</Typography>
          <Typography variant="body2" color="text.secondary">
            Lista consolidada de estudiantes que arrastran materias pendientes, indicando su grupo y código.
          </Typography>

          <TextField
            select
            label="Formato del documento"
            SelectProps={{ native: true }}
            value={formatoArrastre}
            onChange={(e) => setFormatoArrastre(e.target.value)}
            fullWidth
          >
            <option value=""></option>
            <option value="pdf">Documento PDF</option>
            <option value="excel">Documento Excel</option>
          </TextField>

          <Box display="flex" width="100%" mt={2}>
            <MDButton
              variant="contained"
              color="warning"
              onClick={handleReporteArrastre}
              fullWidth
            >
              Generar Reporte de Arrastres
            </MDButton>
          </Box>
        </Box>
        {/* --- NUEVO: Reporte de 3 o más Faltas --- */}
        <Box
          p={3}
          borderRadius={2}
          boxShadow={2}
          bgcolor="#fff"
          display="flex"
          flexDirection="column"
          gap={2}
        >
          <Typography variant="h6">Reporte de 3 o más Faltas</Typography>
          <Typography variant="body2" color="text.secondary">
            Lista de estudiantes que acumulan 3 o más inasistencias en una materia.
          </Typography>

          <TextField
            select
            label="Formato del documento"
            SelectProps={{ native: true }}
            value={formatoFaltas}
            onChange={(e) => setFormatoFaltas(e.target.value)}
            fullWidth
          >
            <option value=""></option>
            <option value="pdf">Documento PDF</option>
            <option value="excel">Documento Excel</option>
          </TextField>

          <Box display="flex" width="100%" mt={2}>
            <MDButton
              variant="contained"
              color="error"
              onClick={handleReporteFaltas}
              fullWidth
            >
              Generar Reporte de Faltas
            </MDButton>
          </Box>
        </Box>
        <Box p={3} borderRadius={2} boxShadow={2} bgcolor="#fff" display="flex" flexDirection="column" gap={2}>
          <Typography variant="h6">Control de Documentos Entregados</Typography>
          <Typography variant="body2" color="text.secondary">
            Verifica qué estudiantes tienen pendientes su Título de Bachiller, CI o Certificado.
          </Typography>

          <TextField
            select
            label="Formato"
            SelectProps={{ native: true }}
            value={formatoDocumentos} // Crea este estado arriba
            onChange={(e) => setFormatoDocumentos(e.target.value)}
            fullWidth
          >
            <option value=""></option>
            <option value="pdf">PDF</option>
            <option value="excel">Excel</option>
          </TextField>

          <MDButton
            variant="contained"
            color="dark"
            fullWidth
            onClick={() => {
              if(!formatoDocumentos) return alert("Seleccione formato");
              const token = sessionStorage.getItem("access_token");
              window.open(`${process.env.REACT_APP_API_URL}/reportes/documentos/${formatoDocumentos}`, "_blank");
            }}
          >
            Generar Reporte de Documentos
          </MDButton>
        </Box>
        {/* --- BLOQUE: Notas por Grupo y Materia --- */}
        <Box p={3} borderRadius={2} boxShadow={2} bgcolor="#fff" display="flex" flexDirection="column" gap={2}>
          <Typography variant="h6">Cuadro de Notas por Grupo</Typography>
          
          <Box display="flex" gap={2}>
            <TextField
              select
              label="Seleccionar Programa"
              SelectProps={{ native: true }}
              value={`${programaNotas.tipo}-${programaNotas.id}`}
              onChange={(e) => {
                const val = e.target.value;
                if (val === "-") {
                  setProgramaNotas({ id: "", tipo: "" });
                  return;
                }
                const [tipo, id] = val.split("-");
                setProgramaNotas({ tipo, id });
              }}
              fullWidth
            >
              <option value="-">Elija una carrera o capacitación...</option>
              {programasUnificados.map((p, index) => (
                <option key={`notas-${p.tipo}-${p.id}-${index}`} value={`${p.tipo}-${p.id}`}>
                  {p.display}
                </option>
              ))}
            </TextField>

            <TextField
              select
              label="Gestión"
              SelectProps={{ native: true }}
              value={gestionNotas}
              onChange={(e) => setGestionNotas(e.target.value)}
              disabled={!programaNotas.id}
              fullWidth
            >
              <option value=""></option>
              {gestiones.map((g) => (
                <option key={g.id} value={g.id}>
                  {g.nombre}
                </option>
              ))}
            </TextField>
            <TextField
              select
              label="Semestre"
              SelectProps={{ native: true }}
              value={semestreSeleccionado}
              onChange={(e) => setSemestreSeleccionado(e.target.value)}
              disabled={semestres.length === 0}
              fullWidth
            >
              <option value=""></option>
              {semestres.map((s, i) => (
                <option key={i} value={s.id}>
                  {s.nombre} {s.numero}
                </option>
              ))}
            </TextField>

            {/* 3. SELECTOR DE GRUPO (Dinámico por Pensum) */}
            <TextField
              select
              label="Grupo"
              SelectProps={{ native: true }}
              value={grupoNotas}
              onChange={(e) => setGrupoNotas(e.target.value)}
              disabled={gruposDisponibles.length === 0}
              fullWidth
            >
              <option value=""></option>
              {gruposDisponibles.map((grupo) => (
                <option key={grupo.id} value={grupo.id}>
                  {grupo.nombre}
                </option>
              ))}
            </TextField>
            
          </Box>
          <TextField
            select
            label="Materia / Módulo a Calificar"
            SelectProps={{ native: true }}
            value={materiaSeleccionada}
            onChange={(e) => setMateriaSeleccionada(e.target.value)}
            disabled={materias.length === 0}
            fullWidth
          >
            <option value=""></option>
            {materias.map((item, i) => (
              <option key={i} value={item.materia_id}>
                {item.nombre_materia} {item.nombre_docente ? `(${item.nombre_docente})` : ''}
              </option>
            ))}
          </TextField>

          <TextField
            select
            label="Formato de Descarga"
            SelectProps={{ native: true }}
            value={formatoNotas}
            onChange={(e) => setFormatoNotas(e.target.value)}
            fullWidth
          >
            <option value=""></option>
            <option value="pdf">PDF (Oficial)</option>
            <option value="excel">Excel (Revisión)</option>
          </TextField>

          <MDButton 
            variant="contained" 
            color="dark" 
            onClick={handleReporteNotasGrupo} 
            fullWidth
            disabled={!grupoNotas}
          >
            Generar Cuadro de Notas
          </MDButton>
        </Box>

  {/* --- BLOQUE: Mejores Promedios --- */}
        <Box p={3} borderRadius={2} boxShadow={2} bgcolor="#fff" display="flex" flexDirection="column" gap={2}>
          <Typography variant="h6">Ranking de Mejores Promedios</Typography>
          <Typography variant="body2" color="text.secondary">
            Genera una lista de los estudiantes con mayor rendimiento académico.
          </Typography>
          <TextField
            select
            label="Ámbito del Reporte"
            SelectProps={{ native: true }}
            // USA programaRanking
            value={programaRanking.id === "todas" ? VALOR_INSTITUCIONAL : `${programaRanking.tipo}-${programaRanking.id}`}
            onChange={(e) => {
              const val = e.target.value;
              if (val === VALOR_INSTITUCIONAL) {
                setProgramaRanking({ id: "todas", tipo: "general" });
              } else {
                const [tipo, id] = val.split("-");
                setProgramaRanking({ tipo, id });
              }
            }}
            fullWidth
          >
            <option value={VALOR_INSTITUCIONAL}>TODO EL INSTITUTO (Ranking General)</option>
            
            <optgroup label="─── CARRERAS TÉCNICAS ───">
              {programasUnificados
                .filter(p => p.tipo === 'carrera')
                .map((p) => (
                  <option key={`rank-carrera-${p.id}`} value={`carrera-${p.id}`}>
                    🎓 {p.display}
                  </option>
                ))}
            </optgroup>

            <optgroup label="─── CAPACITACIONES / CURSOS ───">
              {programasUnificados
                .filter(p => p.tipo === 'capacitacion')
                .map((p) => (
                  <option key={`rank-cap-${p.id}`} value={`capacitacion-${p.id}`}>
                    💻 {p.display}
                  </option>
                ))}
            </optgroup>
          </TextField>

          <Box display="flex" gap={2}>
            <TextField
              select
              label="Semestre"
              SelectProps={{ native: true }}
              value={semestreRanking}
              onChange={(e) => setSemestreRanking(e.target.value)}
              fullWidth
            >
              <option value=""></option>

              {semestres.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.nombre} {s.numero}
                </option>
              ))}
            </TextField>

            <TextField
              select
              label="Gestión"
              SelectProps={{ native: true }}
              value={gestionRendimiento}
              onChange={(e) => setGestionRendimiento(e.target.value)}
              fullWidth
            >
              <option value=""></option>

              {gestiones.map((g) => (
                <option key={g.id} value={g.id}>
                  {g.nombre}
                </option>
              ))}
            </TextField>
          </Box>

          <TextField
            select
            label="Formato"
            SelectProps={{ native: true }}
            value={formatoPromedios}
            onChange={(e) => setFormatoPromedios(e.target.value)}
            fullWidth
          >
            <option value=""></option>
            <option value="pdf">Documento PDF</option>
            <option value="excel">Documento Excel</option>
          </TextField>

          <MDButton variant="contained" color="success" onClick={handleReporteMejoresPromedios} fullWidth>
            Generar Cuadro de Honor
          </MDButton>
        </Box>
      </Box>
    </>
  );
}
